import axios from "axios";
import { API_HOST } from "@/core/variables";

class RoleRepository {
    find = async (agentId: number) => {
        return axios
            .get(`${API_HOST}/v1/agents/${agentId}/roles`)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };
}

const roleRepository = new RoleRepository();
export default roleRepository;

